import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as _ from 'underscore';

import DialogFactory from '../../factory/DialogFactory';
import * as ClipboardState from '../../../state/reducer/clipboard/clipboard';
import Console from '../../../lib/debug';

class DeleteDialog extends Component {
    handleClose() {
        ClipboardState.cancelDeleteDialog();
        ClipboardState.clearSelected();
    }

    handleSave() {
        ClipboardState.deleteSelected();
        ClipboardState.clearSelected();
    }

    header() {
        return 'Are you sure?';
    }

    text() {
        return (
            'Are you sure you want to delete ' +
            this.props.sessionCount +
            ' session(s)?'
        );
    }

    render() {
        Console.render('deleteDialog');
        return (
            <DialogFactory
                enabled={this.props.enabled ? true : false}
                handleClose={this.handleClose}
                handleSave={this.handleSave}
                header={this.header()}
                text={this.text()}
                cancelButtonTitle="Cancel"
                saveButtonTitle="Delete"
                saveOnEnter={true}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        enabled: state.clipboard.deleteDialogEnabled,
        sessionCount: _.keys(state.clipboard.selectedSessions).length
    };
};

export default connect(mapStateToProps)(DeleteDialog);
